import { render, staticRenderFns } from "./DisplayList.vue?vue&type=template&id=2d0e9f48&scoped=true&"
import script from "./DisplayList.vue?vue&type=script&lang=js&"
export * from "./DisplayList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0e9f48",
  null
  
)

export default component.exports